import { render, staticRenderFns } from "./AppWarning.vue?vue&type=template&id=000e2888&scoped=true"
import script from "./AppWarning.vue?vue&type=script&lang=ts"
export * from "./AppWarning.vue?vue&type=script&lang=ts"
import style0 from "./AppWarning.vue?vue&type=style&index=0&id=000e2888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000e2888",
  null
  
)

export default component.exports